export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/axe-b8b6c52200687def494731870dd42470.png";